// common
import React, { useEffect } from "react";
import ReactDOM from "react-dom";

// components
import ButtonGroup from "components/button/ButtonGroup";
import ErrorLayout from "components/error/ErrorLayout";

// hooks
import usePageNavigate from "hooks/common/usePageNavigate";

// icons
import { MdOutlineError } from "react-icons/md";
import { GrRotateLeft } from "react-icons/gr";
import useModal from "hooks/components/useModal";
import BaseModal from "components/modal/BaseModal";

const ServerErrorContent = ({ children }) => {
  const { onNavClick } = usePageNavigate();
  const { visibleModal, openModal, closeModal } = useModal();

  useEffect(() => {
    openModal("serverError", "서버 오류");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {children}
      {ReactDOM.createPortal(
        <BaseModal visible={visibleModal.isopen}>
          <ErrorLayout
            icon={<MdOutlineError />}
            // title="일시적인 오류가 발생했습니다."
            title={
              <>
                서비스 이용에 불편을 드려 죄송합니다.
                <br />
                현재 접속이 원활하게 이루어지지 않고 있습니다.
              </>
            }
            desc={[
              // "문제를 해결하기 위해 열심히 노력하고 있습니다.",
              "잠시 후 다시 시도해주세요.",
            ]}
            button={
              <ButtonGroup
                className="error_content_group"
                button={[
                  {
                    text: "메인으로",
                    variant: "dark-outline",
                    size: "big",
                    onClick: () => {
                      closeModal();
                      onNavClick("/");
                    },
                    gtm: {
                      url: "/",
                      id: "server-error-modal-main-btn",
                    },
                  },
                  {
                    beforeIcon: <GrRotateLeft />,
                    text: "다시 불러오기",
                    variant: "primary",
                    size: "big",
                    className: "error_reload",
                    onClick: () => {
                      closeModal();
                      window.location.reload();
                    },
                    gtm: {
                      url: window.location,
                      id: "server-error-modal-reload-btn",
                    },
                  },
                ]}
              />
            }
          />
        </BaseModal>,
        document.body
      )}
    </>
  );
};

export default ServerErrorContent;
